import styled from "styled-components";

export const ButtonWrapper = styled.span`
  display: flex;
`;
